import React, { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom"; 

function Header() {
  const videoRef = useRef(null); // Reference to the video element

  // Single video source
  const videoSource = "/ai-video2.mp4"; // Path to your video

  const navigate = useNavigate(); // Initialize the navigate function

  // Function to handle button click
  const handleButtonClick = () => {
    // Navigate to the section with class 'services'
    document.querySelector(".services")?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    // Ensure the video starts playing when the component mounts
    const video = videoRef.current;
    if (video) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.log("Autoplay failed: ", error); // Handle the error if autoplay fails
        });
      }
    }
  }, []);

  return (
    <header>
      <video
        ref={videoRef}
        src={videoSource} // Set the video source
        autoPlay
        muted
        playsInline
        preload="auto"
        loop // This ensures the video loops indefinitely
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          position: "absolute",
          top: 0,
          left: 0,
        }}
      ></video>

      <h1>SEIONIC TECHNOLOGIES</h1>
      <h2 className="headerp">
        Powering innovation through seamless technology solutions
      </h2>

      <button
        className="btn"
        style={{ cursor: "pointer", transition: "all 0.3s ease" }}
        onClick={handleButtonClick} // OnClick event to scroll to the services section
      >
        Explore
      </button>

      <div className="headerbg"></div>
    </header>
  );
}

export default Header;
